import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { RequestService } from '@df/api/request/request.service';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { SearchResult } from '@df/search/search-result';
import { SearchService } from '@df/search/search.service';
import { NSearch } from '@df/search/df-search.config';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'any' })
export class PageSearchService {
    /**
     * Search status subject
     */
    readonly state = new BehaviorSubject<SearchResult | undefined>(undefined);
    /**
     * Header search status
     */
    readonly status = new Status();
    /**
     * We will only provide results for currently searched term
     * if term will change we will skip that resul
     */
    private currentSarchTerm?: string;

    /**
     * Dependencies
     */
    constructor(
        private searchService: SearchService,
        @Inject(NSearch.OPTIONS) private searchUonfig: NSearch.IModuleOptions,
        private app: App,
        private requestService: RequestService,
        private router: Router
    ) {}

    /**
     * Search (page header way)
     */
    search(term: string): void {
        this.currentSarchTerm = term;
        if (this.isTermValid(term)) {
            this.requestService.send(this.status, () =>
                this.searchService.search({ q: term, ...this.searchUonfig.options.search }).then(result => {
                    if (this.currentSarchTerm === term) {
                        this.state.next(result);
                    }
                })
            );
        }
    }

    /**
     * Move to search view page
     */
    gotToSearchView(term = this.currentSarchTerm) {
        if (this.isTermValid(term)) {
            this.router.navigate(['/search', term]);
        }
    }

    /**
     * If search term is valid test
     */
    private isTermValid(term?: string): boolean {
        return typeof term === 'string' && term.length > 2;
    }

    /**
     * Reset service state
     */
    reset() {
        this.currentSarchTerm = undefined;
        this.status.busy = false;
        this.state.next(undefined);
    }
}
